import React from 'react';
import { Outlet } from 'react-router-dom';

export const AuthOutLet = () => {
  return (
    <div id="mytask-layout" className="theme-indigo">
      <Outlet />
    </div>
  );
};
